// extracted by mini-css-extract-plugin
export default {"documentContainer":"ComponentWithDocument_documentContainer__VposV","fileName":"ComponentWithDocument_fileName__uNgMP","deleteIcon":"ComponentWithDocument_deleteIcon__j8lvP"};